import { render } from "./administrarRegistos.vue?vue&type=template&id=64598b37&scoped=true"
import script from "./administrarRegistos.vue?vue&type=script&lang=js"
export * from "./administrarRegistos.vue?vue&type=script&lang=js"

import "./administrarRegistos.vue?vue&type=style&index=0&id=64598b37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64598b37"]])

export default __exports__